var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "bottom-content"
    },
    [
      _c(
        "v-btn",
        {
          attrs: {
            block: "",
            color: "primary",
            tile: "",
            to: {
              name: "notifications"
            }
          },
          on: {
            click: function click($event) {
              return _vm.$emit("close")
            }
          }
        },
        [_vm._v(" VIEW ALL NOTIFICATIONS ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }